"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var $modals = document.querySelectorAll('.modal');
var closeModal = function () {
    var _a;
    (_a = document.querySelectorAll('.modal')) === null || _a === void 0 ? void 0 : _a.forEach(function (v) {
        v.classList.remove('open');
    });
};
exports.default = (function () {
    $modals.forEach(function (modal) {
        modal.addEventListener('mouseleave', closeModal);
    });
});
